import React from "react";
import { Box, Grid, Backdrop, Typography } from "@material-ui/core";
import { InputFields } from "./InputFields";
import { useStyles } from "./styles";
import CommonLoader from "src/components/Loader/CommonLoader";

type Props = {
  children?: React.ReactNode;
  index: any;
  value: any;
};

export function AddTerminal({ children, value, index, ...other }: Props): React.ReactElement {
  const classes = useStyles();
  const pageHeading = "Terminals";

  return (
    <div
      role="tabpanel"
      hidden={value !== index}
      id={`vertical-tabpanel-${index}`}
      aria-labelledby={`vertical-tab-${index}`}
      {...other}
    >
      {value === index && (
        <>
          <Backdrop className={classes.backdrop} open={false}>
            <CommonLoader />
          </Backdrop>
          <Box borderColor="grey.200">
            <Typography className={classes.pageHeading}> {pageHeading} </Typography>
            <Box borderTop={2} mb={1} borderColor="grey.200"></Box>
            <Grid container direction="row">
              <Grid item xs={12} md={12}>
                {/* Conent Start */}
                <InputFields />
                {/* Conent End */}
              </Grid>
            </Grid>
          </Box>
        </>
      )}
    </div>
  );
}
